import { IReturnProductType } from '@ve/pages/hotel/types';
import { wordEnding } from '@ve/services/textModifiers';
import {
 ComputedRef, unref, computed, ref,
} from 'vue';

export default function (groupedProducts: ComputedRef<IReturnProductType[][]>, limitProducts: number, strokeEnding: string) {
    const numberCard = ref(1);
    const paginationGroupedProducts = computed(() => {
        const products = [];
        for (let i = 0; i < limitProducts * unref(numberCard); i++) {
            const product = unref(groupedProducts)[i];
            if (product) {
                products.push(product);
            }
        }
        return products;
    });

    const remainderGroupedProducts = computed(() => (unref(groupedProducts).length - unref(paginationGroupedProducts).length));

    const isNextProductsExists = computed(() => unref(remainderGroupedProducts) > 0);

    const paginationText = computed(() => `Показать еще ${limitProducts > unref(remainderGroupedProducts) ? unref(remainderGroupedProducts) : limitProducts} из ${unref(remainderGroupedProducts)} ${wordEnding(unref(remainderGroupedProducts), strokeEnding)}`);

    const updateNumberCard = () => {
        numberCard.value++;
    };

    const resetNumberCard = () => {
        numberCard.value = 1;
    };

    return {
        paginationText,
        isNextProductsExists,
        paginationGroupedProducts,
        updateNumberCard,
        resetNumberCard,
    };
}